import { FunctionComponent, useContext, useEffect } from "react";
import TitleText from "../../components/shared-components/dashboard/TitleText";
import styles from "./AdminDashboard.module.css";
import PendingTickets from "./DashboardComponents/PendingTickets";
import TopSales from "./DashboardComponents/TopSales";
import Revenue from "./DashboardComponents/Revenue";
import { globalContext } from "../../Provider/AppProvider";
import { GET_NOTIFICATIONS } from "../../components/shared-components/notification/api/NotificationQuery";
import { useLazyQuery } from "@apollo/client";
import { getFormattedDate, roles } from "../../helper";

const AdminDashboard: FunctionComponent = () => {
  localStorage.removeItem('ticketsTabIndex');
  localStorage.removeItem('errorTabIndex');
  localStorage.removeItem('settingsTabIndex');
  const title = 'Dashboard'
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const date = getFormattedDate(new Date());

  const [getNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempState = {...globalState}
      tempState.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempState.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempState)
    }
  })

  useEffect(()=>{
    const temp = {...globalState};
    if(globalState.globalSearch.affiliateUsersClicked){
      temp.globalSearch.searchtext = "";
      temp.globalSearch.affiliateUsersClicked = false;
    }
    if(globalState.notification.notificationClicked){
      temp.notification.notificationClicked = false;
      temp.notification.tp_id_array=null;
      temp.globalSearch.searchtext = "";
      temp.notification.text = "";
      temp.notification.ticketId =null;
      temp.notification.tpId = null;
    }else if(globalState.error.errorClicked){
      temp.error.errorClicked = false;
      temp.globalSearch.searchtext = "";
      temp.error.text = "";
      temp.error.approximateTpArray = null
      temp.error.ticketPlacementId = null
      temp.error.status=""
    }else if(globalState.soldTickets.failed){
      temp.soldTickets.failed = false
      temp.globalSearch.searchtext = "";
      temp.soldTickets.emailId = "";
    }
    handleGlobalState(temp);
    if(globalState.profile.userRole !== "marketing_user"){
      getNotification({
        variables:{
          todayDate: date,
          userId: globalState?.profile?.id
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  return (
       <div className={styles.dashboardContainer}>
      <TitleText title={title} />
      <div style={{display:'flex', flexDirection:'column', height:'100%'}}>
      <div className={styles.topSalesAndPendingTickets} style = {globalState.profile.userRole === roles.AFFILIATER_ADMIN ? {height: '100%'} : {}}>
       <TopSales/>
       <PendingTickets/>
      </div>
      {
        globalState.profile.userRole !== roles.AFFILIATER_ADMIN && <div>
          <Revenue/>
        </div>
      }
    </div>
    </div>
  );
};

export default AdminDashboard;
